module.exports = __webpack_public_path__ + "resources/add-circle-filled-a7750fa2f9a6fa64a000feddaa27da43.svg";